import ApiCentralAjuda from "../services/ApiCentralAjuda"
import { AtendimentoPayloadType } from "../types/AtendimentoPayloadType";

export const atendimento = {

    buscarAtendimentosPorSlug: async (slug:string, filtros?:any) => {
        return await ApiCentralAjuda.get(`central-atendimento/atendimento/slug/${slug}`, {params: filtros});
    },

    getTiposAtendimentos:async () => {
        return await ApiCentralAjuda.get('central-atendimento/atendimento/tipo')
    },

    criarAtendimento:async (dados:AtendimentoPayloadType, meioComunicacao:string) => {
        return await ApiCentralAjuda.post(`central-atendimento/atendimento/slug/${meioComunicacao}`, dados)
    },

    enviarMensagem: async (idAtendimento:number, data: any) => {
        return await ApiCentralAjuda.post(`central-atendimento/atendimento/${idAtendimento}/mensagem`, data);
    },

    buscarMensagens: async (id: number, filtros:any) => {
        return await ApiCentralAjuda.get(`central-atendimento/atendimento/${id}/mensagem`, {params: filtros});
    },

    getAtendimentoById: async (id: number,page:number) => {
        return await ApiCentralAjuda.get(`central-atendimento/atendimento/chat/${id}`,{params:{page:page}});
    },

}
